import { useRef } from "react";
/**
 * Hook for checking if the component is rendering for the first time
 * @returns true if the component is rendering for the first time
 */ export function useIsFirstRender() {
    const isFirstRender = useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        return true;
    }
    return false;
}
